const {
  createAsyncActionTypes,
} = require('src/core/util/async-action-type-creator');

export const GET_CONFIG = createAsyncActionTypes('GET_CONFIG');
